<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";
    import {decode, encode} from "../../../helpers";
    import {toastbox} from "../../../utils";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            fetchData = await fetch();

            width.set(json.width)
            height.set(json.height)
            type = json.type
            ind1 = json.ind1
            ind2.set(json.ind2)
            ind3 = json.ind3
            fiksator = json.fiksator
            kreplenie = json.kreplenie

            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    const fetch = async () => {
        let result = await network.fetch_data('МС');
        let options = await network.fetch_ind('МС');

        return {
            polotno: result
                .filter(el => el.name.startsWith('Полотно'))
                .map(el => el.name.replace('Полотно', '').trim().capitalize())
                .sort((a, b) => {
                    if (a === 'Стандарт') return -1; // Стандарт выше
                    if (b === 'Стандарт') return 1;
                    return a.localeCompare(b); // остальные по алфавиту
                }),
            color: result
                .filter(el => el.name.startsWith('Импост МС'))
                .map(el => el.ind2.trim())
                .sort((a, b) => {
                    const order = str =>
                        str === 'Белый' ? 0 :
                            str.includes(' (') ? 2 :
                                str.toLowerCase().includes('покраска') ? 3 :
                                    1;

                    return order(a) - order(b) || a.localeCompare(b);
                }),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),
        type = 'Вставная', // тип сетки
        ind1 = '1', // перемычка
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Стандарт (1.5м)', // полотно
        ugolok = 'Металл', //
        fiksator = '2', // фиксатор для вставной
        kreplenie = '50', // крепление для стандартной

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);
    let
        montage_item,
        montage_price = 1;

    const selectImpost = () => {
        let buf = Math.max($width, $height);

        switch (true) {
            case buf < 600 && ind1 !== '0':
                ind1 = '0'
                toastbox('toast-ind1-0', 3000);
                break;
            case buf >= 600 && ind1 !== '1':
                ind1 = '1'
                toastbox('toast-ind1-1', 3000);
                break;
            case buf >= 1800 && ind1 !== '2':
                ind1 = '2'
                toastbox('toast-ind1-2', 3000);
                break;
        }
    }

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let title = [
            'МС', ' ', type, ' ',
            w + 'x' + h, ' ',
            $ind2, ', полотно: ', ind3, ' ',
            (ind1 === '0' ? 'Нет' : ( ind1 === '1' ? '1 импост' : ' 2 импоста')),
        ].join('')

        let result = {
            type: 'мс',
            name: 'МС',
            subname: title.replace('МС', type.capitalize()).trim(),
            title,
            params: {
                ind1: [
                    type,
                    type === 'Вставная' ?  ('фиксатор - '+ (fiksator === '4' ? '2 низ + 2 верх' : 'Низ + верх')): "крепление " + (kreplenie === '50' ? 'для профиля 50' : ' для профиля 70'),
                    "полотно - " +ind3,
                    (ind1 === '0' ? 'Нет' : ( ind1 === '1' ? '1 импост' : ' 2 импоста'))
                    ].join(', '),
                ind2: $ind2,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    type,
                    ind1,
                    ind2: $ind2,
                    ind3,
                    fiksator,
                    kreplenie,
                })),
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: 91,
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();
            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.startsWith('профиль')) {
                switch (true) {
                    case type === 'Вставная' && item.name.includes('вставной') && $ind2.toLowerCase().includes(item.ind2.toLowerCase()):
                        kolvo = ((2 * w) / 1000+ (2 * h)/ 1000).toFixed(3);
                        break;
                    case type === 'Стандарт' && item.name.includes('стандарт') && $ind2.toLowerCase().includes(item.ind2.toLowerCase()):
                        kolvo = ((2 * w)/ 1000 + (2 * h)/ 1000).toFixed(3);
                        break;
                }
            }

            if (name.startsWith('угол')) {
                switch (true) {
                    case type === 'Вставная' && item.name.includes('для вставной'):
                        kolvo = (4).toFixed(3);
                        break;
                    case type === 'Стандарт' && ($ind2.toLowerCase().includes(item.ind2.toLowerCase()))  && (item.ind2.toLowerCase() !='') :
                        kolvo = (4).toFixed(3);
                        break;
                }
            }


            if (type === 'Стандарт' && !item.name.includes('для вставной') && name.startsWith('угол') && item.ind2.toLowerCase() =='' ) {

                switch (true) {
                    case $ind2 !== 'Белый' && $ind2 !== 'Антрацит (RAL 7016)' && $ind2 !== 'Коричневый (RAL 8017)' :
                        kolvo = (4).toFixed(3);
                        break;
                }
            }

            if (name.startsWith('импост') && $ind2.toLowerCase().includes(item.ind2.toLowerCase()) && ind1 !== '0') {
                kolvo = (Math.min(w, h) * parseFloat(ind1) / 1000).toFixed(3)
            }

            if (name.startsWith('крепление импоста') && ind1 !== '0') {
                kolvo = (2 * parseFloat(ind1)).toFixed(3)
            }

            if (name.startsWith('полотно') && name.includes(ind3.toLowerCase())) {
                kolvo = (w * h / 1000000).toFixed(3);
            }

            if (name.startsWith('шнур')) {
                kolvo = ((w + h) * 2 / 1000).toFixed(3);
            }

            if (name.startsWith('фиксатор для вставной') && type === 'Вставная') {
                kolvo = (parseInt(fiksator)).toFixed(3)
            }

            if (name.startsWith('комплект') && name.includes('креплений') && type === 'Стандарт' && name.includes(kreplenie)) {
                kolvo = (1).toFixed(3)
            }

            if (name.includes('ручка') && type === 'Стандарт') {
                if (h >= 600 && h < 1800) {
                    kolvo = (2).toFixed(3)
                }
                if (h >= 1800) {
                    kolvo = (4).toFixed(3)
                }
            }

            // -----

            if (name.includes('работа')) {
                if (name.includes('вставной') && type === 'Вставная') {
                    kolvo = (1).toFixed(3);
                }
                if (name.includes('стандарт') && type === 'Стандарт') {
                    kolvo = (1).toFixed(3);
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }
            if (name.includes('упаковка')) {
                packing_items.push(item);
            }

        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        result.price.rozn = Math.ceil(result.price.rozn / 10) * 10
        result.price.opt = Math.ceil(result.price.opt / 10) * 10

        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }

        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000 });
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            {#if APP_TYPE === 'plisse-ltd'}
                {@const filename = ($ind2 === 'Белый(9016RAL)' ?
                    '1inw.jpg' : ($ind2 === 'Анодированный(коньяк)' || $ind2 === 'Коричневый(RAL8017)' || $ind2 === 'Антрацит(7016RAL)' ?
                        '2inb.jpg' : 'inc.jpg'
                    )
                )}
                <div class="col-12  text-center d-flex order-last  order-sm-first justify-content-around">
                    <img style="max-height: 250px"
                         class="img-fluid p-3"
                         src="https://iem.plisse.ltd/tradeMasterImages/plisseltd/{filename}"
                         alt="img"
                    />
                </div>
            {/if}

            <div class="col-12">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Тип сетки</label>
                        <select class="form-control form-select" bind:value={type}>
                            <option value="Вставная">Вставная</option>
                            <option value="Стандарт">Стандарт</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each data.polotno as polotno}
                                <option value="{polotno}">{polotno}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2}>
                            {#each data.color as color}
                                <option value="{color}">{color}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group boxed">
                    <div class="alert alert-outline-danger">
                        {#if type === 'Вставная'}
                            К расчету принимаются размеры светового проема!
                        {/if}
                        {#if type === 'Стандарт'}
                            К расчету принимаются размеры светового проема!
                        {/if}
                    </div>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Шир., мм ≥ { options.max && options.max.width ? options.max.width : 1300 }</label>
                        <input type="number" class="form-control" step="10" min="200" max="{ options.max && options.max.width ? options.max.width : 1300 }" on:keyup={selectImpost} bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Выс., мм ≥ { options.max && options.max.height ? options.max.height : 2400 }</label>
                        <input type="number" class="form-control" step="10" min="200" max="{ options.max && options.max.height ? options.max.height : 2400 }" on:keyup={selectImpost} bind:value={$height} use:validate_int={$height}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Импост</label>
                        <select class="form-control form-select" bind:value={ind1}>
                            <option value="0">Нет</option>
                            <option value="1">Есть 1 шт</option>
                            <option value="2">Есть 2 шт</option>
                        </select>
                    </div>
                </div>

                <!--{#if ind1 === 'Нет' && $height > 600}
                    <div class="alert alert-outline-warning">
                        При высоте больше 600 мм рекомендуется поставить импост
                    </div>
                {/if}-->
            </div>

            {#if type === 'Вставная'}
                <div class="col-6">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Фиксаторы</label>
                            <select class="form-control form-select" bind:value={fiksator}>
                                <option value="2">Низ + верх</option>
                                <option value="4">2 низ + 2 верх</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            {#if type === 'Стандарт'}
                <div class="col-6">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Крепление</label>
                            <select class="form-control form-select" bind:value={kreplenie}>
                                <option value="50">Профиль 50</option>
                                <option value="70">Профиль 70</option>
                                <option value="наружних">Наружное</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1-0" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте менее 600 мм можно без перемычки
        </div>
    </div>
</div>
<div id="toast-ind1-1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 600 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
<div id="toast-ind1-2" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1800 мм рекомендуется поставить две перемычки
        </div>
    </div>
</div>

